// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__23fSB","placeholdersHeader":"styles_placeholdersHeader__OBYrd","editorStyle":"styles_editorStyle__3EiOE","placeholdersBox":"styles_placeholdersBox__sQgvK"};